import {
  MainContainer,
  MainContainerWrap,
  SubTitle,
} from "../../styled-components/utils/containerStyles";
import ContactFormMain from "./ContactFormMain";
import {
  ContactBody,
  ContactData,
  ContactDetails,
  ContactHead,
  ContactItem,
  StyledClock,
  StyledContact,
  StyledFaceBook,
  StyledFaMapMarkerAlt,
  StyledFaPhoneAlt,
  StyledHandShake,
  StyledInsta,
  StyledIoIosMail,
  StyledLinkedIn,
  WorkingBody,
} from "./contactStyles";
import MapComponent from "./MapComponent";

const InfoSection = () => {
  return (
    <>
      <MainContainerWrap half>
        <MainContainer
          style={{
            alignItems: "flex-start",
            color: "black",
            margin: "80px 0",
          }}
        >
          <ContactData>
            <SubTitle style={{ marginBottom: "30px" }}>Get In Touch</SubTitle>
            <ContactDetails>
              <ContactHead>
                <StyledContact />
                <SubTitle style={{ fontSize: "1.5rem", marginBottom: "8px" }}>
                  Contact Details
                </SubTitle>
              </ContactHead>
              <ContactBody noStyle={true}>
                <ContactItem justify={"flex-start"}>
                  <StyledFaMapMarkerAlt style={{ marginTop: "5px" }} />
                  <p>
                    F-01/ A-37, Haware Centurion Mall, <br />
                    Nerul, NaviMumbai, 400706,
                    <br />
                    Maharashtra.
                  </p>
                </ContactItem>
                <ContactItem>
                  <StyledFaPhoneAlt />
                  91525 61219 | 97692 41709
                </ContactItem>
                <ContactItem>
                  <StyledIoIosMail />
                  associates@valawoffices.com
                </ContactItem>
              </ContactBody>
            </ContactDetails>
            <ContactDetails>
              <ContactHead>
                <StyledClock />
                <SubTitle style={{ fontSize: "1.5rem", marginBottom: "8px" }}>
                  Working Hours
                </SubTitle>
              </ContactHead>
              <ContactBody noStyle={true}>
                <ContactItem>
                  Monday to Saturday: 10.00 AM – 7.00 PM
                </ContactItem>
                <ContactItem>Sunday: Closed</ContactItem>
              </ContactBody>
            </ContactDetails>
            <ContactDetails>
              <ContactHead>
                <StyledHandShake />
                <SubTitle style={{ fontSize: "1.5rem", marginBottom: "8px" }}>
                  Follow Us
                </SubTitle>
              </ContactHead>
              <WorkingBody>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/valawoffices/"
                >
                  <StyledInsta />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/Valawoffices"
                >
                  <StyledFaceBook />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/company/vidhigya-associates/"
                >
                  <StyledLinkedIn />
                </a>
              </WorkingBody>
            </ContactDetails>
          </ContactData>
          <ContactFormMain />
        </MainContainer>
      </MainContainerWrap>
      <MainContainerWrap half>
        <MapComponent />
      </MainContainerWrap>
    </>
  );
};

export default InfoSection;
